@if (placeholder) {
  <div class="chart-legend flex-md-row flex-column flex-wrap">
    @for (line of placeholderLines; track line) {
      <div class="d-flex align-items-center fs-16">
        <div></div>
        <span class="legend-label">Libellé</span>
        <span class="mlxs">00 000</span>
      </div>
    }
  </div>
}
@if (!placeholder && isRedirect) {
  <div class="chart-legend flex-md-row flex-column flex-wrap">
    @for (data of series; track data; let i = $index) {
      <div class="d-flex align-items-center fs-16">
        @if (data.name) {
          <div [style.background-color]="data.color || options.colors[i]"></div>
          <a
            class="legend-label"
            href="#/dashboard/{{
              arrToRedirect[data.name.replace(' ', '').toLowerCase()]
                ? arrToRedirect[data.name.replace(' ', '').toLowerCase()]
                : 'global'
            }}"
            >{{ data.name }}
          </a>
          @if (showValues) {
            <span class="mlxs">{{
              (value(data) * 1 > 0
                ? (value(data) | number: '.0-0')
                : value(data)) + unity
            }}</span>
          }
        }
      </div>
    }
  </div>
}
@if (!placeholder && !isRedirect) {
  <div class="chart-legend flex-md-row flex-column flex-wrap">
    @for (data of series; track data; let i = $index) {
      <div class="d-flex align-items-center fs-16">
        @if (data.name && value(data) > 0) {
          <div [style.background-color]="data.color || options.colors[i]"></div>
          <span class="legend-label">{{ data.name }}</span>
          @if (showValues) {
            <span class="mlxs">{{
              (value(data) * 1 > 0
                ? (value(data) | number: '.0-0')
                : value(data)) + unity
            }}</span>
          }
        }
      </div>
    }
  </div>
}
